import { create } from 'zustand';

export const useReviewFormStore = create((set, get) => ({
  // Form fields
  restaurantName: '',
  restaurantLocation: '',
  cuisineTypes: '',
  description: '',
  insiderTips: '',
  visibility: 'premium',
  rating: 6,
  photos: [],
  dishes: [],
  selectedPhotoIndex: null,

  // Setters
  setRestaurantName: (name) => set({ restaurantName: name }),
  setRestaurantLocation: (location) => set({ restaurantLocation: location }),
  setCuisineTypes: (types) => set({ cuisineTypes: types }),
  setDescription: (desc) => set({ description: desc }),
  setInsiderTips: (tips) => set({ insiderTips: tips }),
  setVisibility: (visibility) => set({ visibility }),
  setRating: (rating) => set({ rating }),
  setPhotos: (photos) => set({ photos }),
  setDishes: (dishes) => set({ dishes }),
  setSelectedPhotoIndex: (index) => set({ selectedPhotoIndex: index }),

  // Photo management
  addPhotos: (newPhotos) => set((state) => ({ photos: [...state.photos, ...newPhotos] })),
  removePhoto: (index) =>
    set((state) => ({
      photos: state.photos.filter((_, i) => i !== index),
      dishes: state.dishes
        .filter((d) => d.photo_index !== index)
        .map((d) => ({
          ...d,
          photo_index: d.photo_index > index ? d.photo_index - 1 : d.photo_index,
        })),
      selectedPhotoIndex:
        state.selectedPhotoIndex === index ? null : state.selectedPhotoIndex,
    })),

  // Dish management
  updateDish: (photoIndex, field, value) =>
    set((state) => {
      const existingDishIndex = state.dishes.findIndex(
        (d) => d.photo_index === photoIndex
      );
      let newDishes;

      if (existingDishIndex >= 0) {
        newDishes = [...state.dishes];
        newDishes[existingDishIndex] = {
          ...newDishes[existingDishIndex],
          [field]: value,
        };
      } else {
        newDishes = [
          ...state.dishes,
          { photo_index: photoIndex, dish_name: '', notes: '', [field]: value },
        ];
      }

      return { dishes: newDishes };
    }),

  // Get form data - formatted for backend API
  getFormData: () => {
    const state = get();
    return {
      restaurant: {
        name: state.restaurantName,
        location: state.restaurantLocation,
        cuisine_types: state.cuisineTypes
          .split(',')
          .map((c) => c.trim())
          .filter(Boolean),
      },
      description: state.description,
      insider_tips: state.insiderTips || null,
      visibility: state.visibility,
      rating: state.rating,
      photos: state.photos,
      dishes: state.dishes.filter((d) => d.dish_name || d.notes),
    };
  },

  // Reset form
  resetForm: () =>
    set({
      restaurantName: '',
      restaurantLocation: '',
      cuisineTypes: '',
      description: '',
      insiderTips: '',
      visibility: 'premium',
      rating: 6,
      photos: [],
      dishes: [],
      selectedPhotoIndex: null,
    }),
}));
